<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore.js";
import { library } from "@common/library/library";
import { configStore } from "@common/configStore";

const templatePreviewConfig = {
    cId: "templatePreview",
    cType: "templatePreview",
    cTitle: "Template Preview",
    cTemplate: `<div class="template-preview" v-if="!templateReloading" :data-test-id="testStoreId">
                    Template Preview Area {{templateId}}
                    <div v-if="testTemplateConfig" class="template-preview-area">
                        <layout-container :test-config="testTemplateConfig" :unique-store-id="testStoreId"></layout-container>
                    </div>
                </div>`
};

let locals = {
    getRealData(defaultVal, compState) {
        let output = defaultVal;
        if (typeof defaultVal === 'string' && defaultVal.indexOf('this') !== -1) {
            output = compState[defaultVal.split('.')[1]];
        }
        return output;
    },
    generateTestConfig(compState, templateList) {
        let outputSettings = {
            settings: {},
            positions: []
        };
        let template = templateList.find((tmpTemplate) => tmpTemplate.id === compState.templateId);
        template.positions.forEach((position, index) => {
            outputSettings.positions[index] = {
                components: [{ cId: 'positionPlaceholder__' + position.label + '__' + (position.posIndex + 1), cType: 'positionPlaceholder' }]
            };
        });
        if (template.storeProps) {
            outputSettings.storeProps = template.storeProps.map((prop) => ({
                "property": prop.property,
                "default": locals.getRealData(prop.default, compState)
            }));
        }
        if (template.layoutDatamap) outputSettings.layoutDatamap = template.layoutDatamap;
        if (template.settings) outputSettings.settings = template.settings;
        outputSettings.templateFile = template.templateFile;
        return outputSettings;
    }
};

let templatePreviewCmp = {
    name: 'templatePreview',
    props: {
        templateId: {
            default: false
        },
        testStoreId: {
            type: String,
            default: 'devdash_test_window'
        }
    },
    data() {
        return {
            currentTemplateId: undefined,
            templateReloading: false,
            testTemplateConfig: false
        };
    },
    watch: {
        templateId: async function () {
            this.templateReloading = true;
            await library.timeout(100); // NOSONAR
            let templateList = await configStore.getTemplateList();
            this.testTemplateConfig = locals.generateTestConfig(this, templateList);
            await library.timeout(1000); // NOSONAR
            this.templateReloading = false;
        }
    },
    components: {
        layoutContainer: defineAsyncComponent(() => import('@common/layoutContainer/layoutContainer')),
        "ejs-button": defineAsyncComponent(() => import('@common/syncfusion/button')),
    }
};
componentStore.initComponent(templatePreviewCmp, templatePreviewConfig);
export default templatePreviewCmp;
</script>

<style>

[cid=templatePreview], .template-preview, .template-preview .template-preview-area {
    height: 100%;
}
</style>
